import { UtilityService } from '../../../infrastructure/services/utils';
import { store } from '../../store';
import { AnalyticsModel } from './AnalyticsModel';
import { AnalyticsConstants } from './constants';
import { AnalyticsActions } from './IAnalyticsTasks';
import { ISearch } from './ISearch';

/**
 * create model for analytics api payload
 * @param   {object} data api payload data
 * @param   {sting} idToken authentication token
 */
export class SearchModel extends AnalyticsModel {
  constructor(data: ISearch) {
    const paxContextGuid = UtilityService.generateGuid();
    super(data, paxContextGuid);
    const { latency } = store.getState().search;
    const isSemantic = data.Query && data?.Query.trim().split(/\s+/).length >= 4 ? "semanticsearch" : "keywordsearch"
    const site = window.location.origin
      ? `${window.location.origin}#${isSemantic}`
      : null;

    if (this.analyticsData.eventData) {
      this.analyticsData.query = [
        {
          ...this.analyticsData.eventData,
          Query: data.Query ? data.Query : null,          
          SearchURL: window.location.href ? window.location.href : null,
          Latency: latency ? latency : 0,
          WasSuggested:
            data.WasSuggested === AnalyticsConstants.trueString
              ? AnalyticsConstants.trueString
              : AnalyticsConstants.falseString,
          WasRecentSearch:
            data.WasRecentSearch === AnalyticsConstants.trueString
              ? AnalyticsConstants.trueString
              : AnalyticsConstants.falseString,
          Results: data.Results ? data.Results : 0,
          Vertical: data.Vertical ? data.Vertical : null,
          PageURL: (window.location.origin + '/#' + data.PageURL) ? window.location.origin + '/#' + data.PageURL : null,
          Action: AnalyticsActions.query,
          Issues: [AnalyticsConstants.NoIssues],
          Site: site
        }
      ];
      delete this.analyticsData.eventData;
    }
  }
}
